import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ServerService } from './ServerService';

@Injectable({
  providedIn: 'root'
})
export class SuporteWhatsappService extends ServerService {
  constructor(protected http: HttpClient) {
    super(http);
  }

  obtenhaContexto(chatId: string, nomeGrupo: string): Promise<any> {
    return this.facaPost('/suporte/whatsapp/contexto', { chatId, nomeGrupo });
  }

  vinculeGrupo(chatId: string, nomeGrupo: string, empresaSuporteId: number): Promise<any> {
    return this.facaPost('/suporte/whatsapp/grupos/vincular', {
      chatId,
      nomeGrupo,
      empresaSuporteId
    });
  }

  desvinculeGrupo(chatId: string, nomeGrupo: string, justificativa: string): Promise<any> {
    return this.facaPost('/suporte/whatsapp/grupos/desvincular', {
      chatId,
      nomeGrupo,
      justificativa
    });
  }

  listeEmpresas(termo: string): Promise<any[]> {
    return this.obtenha('/suporte/empresas', { termo: termo || '' });
  }

  obtenhaAcoesRapidas(empresaId: number): Promise<any> {
    return this.obtenha('/suporte/empresas/' + empresaId + '/acoes-rapidas', {});
  }

  aproveCampanha(empresaId: number, campanhaId: number, auditoria: any): Promise<any> {
    return this.facaPost('/suporte/empresas/' + empresaId + '/campanhas/' + campanhaId + '/aprovar', auditoria || {});
  }

  fecheLoja(empresaId: number, tempo: number, mensagem: string, auditoria: any): Promise<any> {
    return this.facaPost('/suporte/empresas/' + empresaId + '/loja/fechar', {
      tempo,
      mensagem,
      ...(auditoria || {})
    });
  }

  abraLoja(empresaId: number, auditoria: any): Promise<any> {
    return this.facaPost('/suporte/empresas/' + empresaId + '/loja/abrir', auditoria || {});
  }

  desbloqueieEmergencialmente(empresaId: number, auditoria: any): Promise<any> {
    return this.facaPost('/suporte/empresas/' + empresaId + '/desbloqueio-emergencial', auditoria || {});
  }

  processeRodizioMensagem(dados: any): Promise<any> {
    return this.facaPost('/suporte/whatsapp/rodizio/evento', dados);
  }

  aceiteRodizioAtendimento(id: number): Promise<any> {
    return this.facaPost('/suporte/whatsapp/rodizio/atendimentos/' + id + '/aceitar', {});
  }
}
